import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import dispositionActivities from "./components/dispositionActivities";
import listActivitiesup from "./components/listActivitiesup";
import configurationActivities from "./components/configurationActivities";
import fileActivities from "./components/fileActivities";
import listActivities from "./components/listActivities";
import typeActivities from "./components/typeActivities";
export default {
  name: "activities",
  components: {
    configurationActivities: configurationActivities,
    listActivitiesup: listActivitiesup,
    fileActivities: fileActivities,
    listActivities: listActivities,
    typeActivities: typeActivities,
    dispositionActivities: dispositionActivities
  },
  data: function data() {
    return {
      activeIndex: 'dispositionActivities'
    };
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    modelChange: function modelChange(e) {
      if (this.activeIndex != e) {
        this.$refs[e].domShow && this.$refs[e].domShow();
      }

      this.activeIndex = e;
    },
    editingAc: function editingAc(row) {
      this.modelChange('dispositionActivities');
      this.$bus.$emit('editingAc', row);
    },
    editingDi: function editingDi(row) {
      this.modelChange('configurationActivities');
      this.$bus.$emit('editingDi', row);
    }
  }
};